import React, {useEffect, useState} from 'react'
import {ReactComponent as IconCheckBlack} from '../../../../images/begtest/bb-check_black.svg'
import {ReactComponent as IconCheckGrey} from '../../../../images/begtest/bb-check_grey.svg'
import {ReactComponent as IconExclamationGrey} from '../../../../images/begtest/bb-exclamation_grey.svg'
import {ReactComponent as IconExclamationRed} from '../../../../images/begtest/bb-exclamation_red.svg'
import {ReactComponent as IconListGrey} from '../../../../images/begtest/bb-list_grey.svg'
import {ReactComponent as IconListRed} from '../../../../images/begtest/bb-list_red.svg'
import breakPoints from "../../../../helpers/breakPoints";

export default function BegTestRow({ data }) {
  const [innerWidth, setInnerWith] = useState(window.innerWidth)
  const {breakpoints} = breakPoints;
  const isSmallScreen = () => innerWidth < breakpoints.md;

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleResize = () => setInnerWith(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <li className="grid-container">
      <div className="indicator-description">
        {data.description}
      </div>

      <div>

        <IndicatorCondition data={data} />

        <div className="note-container">
          {isSmallScreen() &&
            <span className={`result ${data.styleAsWarning ? 'text-warning' : ''}`}>
              {data.result}
            </span>
          }
          {data.notes.map((note, index) => (
            <div className="indicator-notes" key={index}>{note}</div>
          ))}
        </div>
      </div>

      {!isSmallScreen() &&
        <div className={`result-container`}>
          <span className={`${data.styleAsWarning ? 'text-warning' : ''}`}>
            {data.result}
          </span>
        </div>
      }
    </li>
  )
}

function IndicatorCondition({ data }) {
  let dataTypeMaxIndex = {
    checks: 3,
    condition: 5
  }

  function getRange() {
    return data.indicatorMax > 3 ? [1, 2, 3, 4, 5] : [1,0, 2,0, 3]
  }

  function getCompletionState(index) {
    if (data.indicatorMax === dataTypeMaxIndex.condition) {
      return index < data.indicatorCurrent ?
        'complete' : index === data.indicatorCurrent ?
          'in-progress' : ''
    } else {
      return index === data.indicatorCurrent ?
        'in-progress' : ''
    }
  }

  function getIndicatorSymbol(index) {
    if (data.indicatorMax === dataTypeMaxIndex.condition) {
      return index === data.indicatorCurrent ? index : ''
    } else {
      switch (index) {
        case 1:
          return data.indicatorCurrent > 1 ? <IconExclamationGrey/> : <IconExclamationRed/>
        case 2:
          return data.indicatorCurrent === 2 ? <IconListRed/> : <IconListGrey/>
        case 3:
          return data.indicatorCurrent >= 3 ? <IconCheckBlack/> : <IconCheckGrey/>
        default:
          return ''
      }
    }
  }

  function nodeClassName() {
    return data.indicatorMax === 5 ? "node" : "node node-no-size";
  }

  return (
    <div className="indicator-progress">
      {getRange().map(index => (
        <div className={`step ${getCompletionState(index)}`}>
          <div className={nodeClassName()}>
            {
              data.indicatorMax === 5
                  ? <div><span>{getIndicatorSymbol(index)}</span></div>
                  : getIndicatorSymbol(index)
            }
          </div>
        </div>
      ))}
    </div>
  )
}